import React from "react"
import ScrollToTop from "react-scroll-up"
import {Button} from "reactstrap"
import {ArrowUp} from "react-feather"
import classnames from "classnames"
import {FormattedMessage} from "react-intl";

const Footer = props => {
    let footerTypeArr = ["sticky", "static", "hidden"]
    return (
        <footer
            className={classnames("footer footer-light", {
                "footer-static": props.footerType === "static" || !footerTypeArr.includes(props.footerType),
                "d-none": props.footerType === "hidden"
            })}
        >
            <p className="mb-0 clearfix">
                کلیه حق و حقوق وبسایت برای کافی بین محفوظ است
            </p>
            <p className="mb-0 clearfix">
                این وبسایت توسط
                {" "}
                <a href="https://barantm.ir"
                   target="_blank"
                   rel="noopener noreferrer"
                >
                    شرکت توسعه نرم افزاری باران </a>
                {" "}
                طراحی و تولید شده است.
                © {new Date().getFullYear()}
            </p>
            {props.hideScrollToTop === false ? (
                <ScrollToTop showUnder={160}>
                    <Button color="primary" className="btn-icon scroll-top">
                        <ArrowUp size={15}/>
                    </Button>
                </ScrollToTop>
            ) : null}
        </footer>
    )
}

export default Footer
